import { styled, SxProps, Theme } from "@mui/material";

type CurrencyLabelProps = {
  currency?: string;
  sx?: SxProps<Theme>;
};

const CurrencyLabel = ({ sx, currency }: CurrencyLabelProps) => {
  return <TreeText sx={sx}>{currency || "TR3"}</TreeText>;
};

const TreeText = styled("span")`
  font-family: IBM Mono, monospace;
  font-size: 16px;
  font-weight: normal;

  color: ${({ theme }) => theme.palette.text.disabled};

  margin-left: 6px;

  @media (max-width: 992px) {
    font-size: 14px;
  }
`;
export default CurrencyLabel;
